import { c as createBreakpointConfigPlugin } from "./create-service-5c5281a7.mjs";
import { v as vaBreakpointSymbol } from "../index-a161fafe.mjs";
import { d as defineVuesticPlugin } from "../../vue-plugin/utils/define-vuestic-plugin-8c565dfe.mjs";
import { d as defineGlobalProperty } from "../../vue-plugin/utils/global-properties-9524ee5b.mjs";
const BreakpointConfigPlugin = defineVuesticPlugin(() => ({
  install(app) {
    const breakpointConfig = createBreakpointConfigPlugin(app);
    app.provide(vaBreakpointSymbol, breakpointConfig);
    defineGlobalProperty(app, "$vaBreakpoint", breakpointConfig);
  }
}));
export {
  BreakpointConfigPlugin as B
};
//# sourceMappingURL=index-4017b4c5.mjs.map
